/**
 * useDataTableUtils
 */
import { useState } from 'react';
import { InvoiceDto } from 'src/generated/services/TFinancialApi';
import { MassActionType } from 'src/presentations/components/organisms/dashboard/types';

/**
 * Hook for invoice table
 */
const useDataTableUtils = () => {
  const [actionType, setActionType] = useState<MassActionType>(null);
  const [isActionLoading, setIsActionLoading] = useState<boolean>(false);
  const [isShowActionResult, setIsShowActionResult] = useState<boolean>(false);
  const [isShowActionConfirm, setIsShowActionConfirm] = useState<boolean>(false);

  /**
   * onClickMassAction
   */
  const onClickMassAction = (type: MassActionType) => {
    setActionType(type);
    setIsShowActionConfirm(true);
  };

  /**
   * onSubmitMassAction
   */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const onSubmitMassAction = (selectedItems: InvoiceDto[] = []) => {
    setIsActionLoading(true);

    setTimeout(() => {
      setIsActionLoading(false);
      setIsShowActionConfirm(false);
      setIsShowActionResult(true);
    }, 3000);
  };

  return {
    actionType,
    isShowActionResult,
    isShowActionConfirm,
    isActionLoading,

    setIsShowActionConfirm,
    setIsShowActionResult,
    onClickMassAction,
    onSubmitMassAction,
  };
};

export default useDataTableUtils;
